import { useSuspenseQuery } from "@tanstack/react-query";
import api from "apis";
import { GetMyDeskDocumentCategoriesParams } from "apis/data-contracts";

const useDocumentCategoriesQuery = (
  options: GetMyDeskDocumentCategoriesParams = {},
) => {
  return useSuspenseQuery({
    queryKey: api.document.getMyDeskDocumentCategoriesKey(options),
    queryFn: () => api.document.getMyDeskDocumentCategories(options),
  });
};

export default useDocumentCategoriesQuery;
